import { defaultCenter, defaultZoom } from "../Components/Map/MapLogic";
import { IMapMarker } from "../Models/IMapMarker";
import { IMapPolygon } from "../Models/IMapPolygon";
import {
    MapActionType,

    SET_LOADING_OVERLAY,
    SET_MAP_CENTER,
    SET_MAP_MARKERS_NEW,
    SET_MAP_ZOOM,
} from "../Types/MapActionTypes";

export interface IMapReducerState {
    markers: IMapMarker[];
    polygons: IMapPolygon[];
    center: google.maps.LatLng;
    zoom: number;
    showLoadingOverlay: boolean;
}

export const mapReducerState: IMapReducerState = {
    markers: [],
    polygons: [],
    center: defaultCenter,
    zoom: defaultZoom,
    showLoadingOverlay: false
};

export const mapReducer = (
    state: IMapReducerState = { ...mapReducerState },
    action: MapActionType
): IMapReducerState => {
    switch (action.type) {
    /** misc */
        case SET_MAP_MARKERS_NEW: {
            const incomingMarkers = action.data as IMapMarker[];
            const newMarker = incomingMarkers.length > 0 ?incomingMarkers[incomingMarkers.length - 1] : null;

            return {
                ...state,
                markers: incomingMarkers,
                center: newMarker
                    ? new google.maps.LatLng(newMarker.lat, newMarker.lng)
                    : defaultCenter,
            };
        }
        case SET_MAP_CENTER: {
            return {
                ...state,
                center: action.data as google.maps.LatLng
            };
        }
        case SET_MAP_ZOOM: {
            return {
                ...state,
                zoom: action.data as number
            };
        }

        case SET_LOADING_OVERLAY: {
            return {
                ...state,
                showLoadingOverlay: action.data as boolean
            };
        }
        default: {
            return state;
        }
    }
};
